import type { JSX } from "solid-js"
import {
  rowClass,
  tableClass,
  tdClass,
  tdNowrapClass,
  tdTruncateClass,
  thClass,
} from "./_publication-table.css"

function PublicationTable(props: { children: JSX.Element }) {
  return <table class={tableClass}>{props.children}</table>
}

function Head(props: { children: JSX.Element }) {
  return (
    <thead>
      <tr>{props.children}</tr>
    </thead>
  )
}

function Body(props: { children: JSX.Element }) {
  return <tbody>{props.children}</tbody>
}

interface RowProps {
  children: JSX.Element
  onClick?: () => void
}

function Row(props: RowProps) {
  return (
    <tr class={props.onClick ? rowClass : undefined} onClick={props.onClick}>
      {props.children}
    </tr>
  )
}

function Header(props: { children?: JSX.Element }) {
  return <th class={thClass}>{props.children}</th>
}

type CellVariant = "default" | "nowrap" | "truncate"

interface CellProps {
  children?: JSX.Element
  variant?: CellVariant
}

function Cell(props: CellProps) {
  const variantClass = () => {
    if (props.variant === "nowrap") return `${tdClass} ${tdNowrapClass}`
    if (props.variant === "truncate") return `${tdClass} ${tdTruncateClass}`
    return tdClass
  }

  return <td class={variantClass()}>{props.children}</td>
}

PublicationTable.Head = Head
PublicationTable.Body = Body
PublicationTable.Row = Row
PublicationTable.Header = Header
PublicationTable.Cell = Cell

export { PublicationTable }
